import { ITableRowData } from "../../../manager/components/data-table/data-table";

interface IBackendManagerConfig {
  id: string;
  manager_alertcase_id: string;
  suspicious_definition: string;
  suspicious_positive: string;
  suspicious_negative: string;
}

export function transformToBackendManagerConfig(data: ITableRowData) {
  return {
    id: data.id,
    manager_alertcase_id: data.manager_alertcase_id,
    suspicious_definition: data.suspicious_definition,
    suspicious_positive: data.suspicious_positive,
    suspicious_negative: data.suspicious_negative
  };
}

export function transformFromBackendManagerConfig(backendType: IBackendManagerConfig) {
  return {
    id: backendType.id,
    manager_alertcase_id: backendType.manager_alertcase_id,
    suspicious_definition: backendType.suspicious_definition,
    suspicious_positive: backendType.suspicious_positive,
    suspicious_negative: backendType.suspicious_negative
  };
}
